import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static values = {
    animation: Number,
    handle: String,
    group: String
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: this.animationValue || 150,
      handle: this.hasHandleValue ? this.handleValue : undefined,
      group: this.hasGroupValue ? this.groupValue : undefined,
      ghostClass: "opacity-50",
      dragClass: "sortable-drag",
      onEnd: this.handleEnd.bind(this)
    });
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  }

  handleEnd(event) {
    // Dispatch custom event for other controllers to listen
    const sortEvent = new CustomEvent("font-upload--sortable:sorted", {
      detail: {
        oldIndex: event.oldIndex,
        newIndex: event.newIndex,
        item: event.item
      },
      bubbles: true
    });

    this.element.dispatchEvent(sortEvent);
  }
}